import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImport: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"import, download, save"} maskId="square-filled-radius-0-stroke-1-IconImport"><path d="M2 4V5H7C9.48528 5 11.5 7.01472 11.5 9.5V14.0429L8.25 10.7929L7.54289 11.5L12 15.9571L16.4571 11.5L15.75 10.7929L12.5 14.0429V9.5C12.5 6.46243 10.0376 4 7 4H2Z" fill="currentColor"/><path d="M15 4V5H21V19H3V8H2V20H22V4H15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconImport;
